<template>
  <unicom-layout-cartao-step
    style="padding-top: 16px"
    :abas="abas"
    v-slot="{ indexAba }"
    :objetoEstiloCartao="{ 'min-height': '350px' }"
  >
    <keep-alive>
      <component
        v-bind="propsAtual(indexAba)"
        @iniciar-prestador="$emit('iniciar-prestador')"
        @lista-arquivos-vazio="listaArquivosVazio"
        :idRnpPrestador="idRnpPrestador"
        :key="indexAba"
        :is="abas[indexAba].tab"
      />
    </keep-alive>
  </unicom-layout-cartao-step>
</template>

<script>
import TabDadosGerais from "./TabDadosGerais/TabDadosGerais";
import TabAlteracoes from "./TabAlteracoes/TabAlteracoes";
import TabEnderecos from "./TabEnderecos/TabEnderecos";
import TabAnexos from "./TabAnexos/TabAnexos";
import { EnumPerfis } from "../../../../shared/helpers/Enum";
import axios from "axios";

export default {
  components: {
    TabDadosGerais,
    TabAlteracoes,
    TabEnderecos,
    TabAnexos
  },
  props: {
    idRnpPrestador: {
      type: [String, Number],
      default: -1
    },
    podeAprovarReprovar: {
      type: Boolean
    },
    podeEnviarArquivo: {
      type: Boolean
    },
    codigoUnimed: {
      type: [Number, String]
    },
    exibeAbaDeExclusao: {
      type: Boolean
    }
  },
  data() {
    return {
      abas: [
        {
          nome: "ALTERAÇÕES",
          ativo: true,
          atual: true,
          tab: "TabAlteracoes"
        },
        {
          nome: "DADOS GERAIS",
          ativo: true,
          atual: false,
          tab: "TabDadosGerais"
        },
        {
          nome: "ENDEREÇOS",
          ativo: true,
          atual: false,
          tab: "TabEnderecos"
        } //,
        // {
        //   nome: "ANEXOS",
        //   ativo: true,
        //   atual: false,
        //   tab: "TabAnexos"
        // }
      ],
      habilitarAbaAnexo: false
    };
  },
  beforeMount() {
    this.getHabilitarAnexos();
    this.atualizarAbas();
  },
  methods: {
    atualizarAbas() {
      if (this.exibeAbaDeExclusao) {
        this.ativarPrimeiraAba();
        return;
      }
      this.desativarPrimeiraAba();
    },
    propsAtual(indexAba) {
      if (indexAba === 0) {
        return {
          podeAprovarReprovar: this.podeAprovarReprovar,
          podeEnviarArquivo: this.podeEnviarArquivo,
          codigoUnimed: this.codigoUnimed
        };
      }
    },
    listaArquivosVazio(isSingular) {
      if (!isSingular) return;
      if (!this.exibeAbaDeExclusao) {
        this.desativarPrimeiraAba();
      }
    },
    desativarPrimeiraAba() {
      this.$set(this.abas[0], "ativo", false);
      this.$set(this.abas[0], "atual", false);
      if (this.habilitarAbaAnexo) {
        this.$set(this.abas[3], "atual", true);
      } else {
        this.$set(this.abas[1], "atual", true);
      }
    },
    ativarPrimeiraAba() {
      if (this.abas[0].ativo) return;

      this.$set(this.abas[0], "ativo", true);
      this.$set(this.abas[0], "atual", true);
      this.$set(this.abas[1], "atual", false);
      this.$set(this.abas[2], "atual", false);
      this.$set(this.abas[3], "atual", false);
    },
    async getHabilitarAnexos() {
      const resposta = await axios.get(
        this.CriarUrl({
          resource: "parametros?chave=enable.abaAnexos.rule"
        })
      );
      let abaAnexos = {
        nome: "ANEXOS",
        ativo: false,
        atual: false,
        tab: "TabAnexos"
      };

      if (!resposta) return;

      if (resposta.data.valor === "true" && this.abas.length < 4) {
        this.abas.push(abaAnexos);
        this.desativarAbaAnexo();
        this.habilitarAbaAnexo = true;
      }
    },
    desativarAbaAnexo() {
      if (this.acessarAbaAnexo) {
        this.$set(this.abas[3], "ativo", true);
      }
    }
  },
  computed: {
    acessarAbaAnexo() {
      return (
        this.papelUsuarioMixin.chave === EnumPerfis.SINGULAR ||
        this.papelUsuarioMixin.chave === EnumPerfis.ADMINISTRADOR ||
        this.papelUsuarioMixin.chave === EnumPerfis.GTR ||
        this.papelUsuarioMixin.chave === EnumPerfis.UB_CONSULTA ||
        this.papelUsuarioMixin.chave === EnumPerfis.FEDERACAO_CONSULTA
      );
    }
  },
  watch: {
    exibeAbaDeExclusao() {
      this.atualizarAbas();
    }
  }
};
</script>

<style></style>
